import React from 'react'
import _ from 'lodash'
import Field from '../../common/FormField'

const JewelryInfo = ({ data, error, onChangeFactory, disabled }) =>
  <fieldset>
    <Field name="Condition">
      <div className="row">
        <div className="col col-2">
          <label className="radio">
            <input
              type="radio"
              name="jewelryConditionGroup"
              value="new"
              checked={data.jewelryCondition === 'new'}
              onChange={onChangeFactory('jewelryCondition')}
              disabled={disabled}
            />
            <i />New
          </label>
        </div>
        <div className="col col-2">
          <label className="radio">
            <input
              type="radio"
              name="jewelryConditionGroup"
              value="used"
              checked={data.jewelryCondition === 'used'}
              onChange={onChangeFactory('jewelryCondition')}
              disabled={disabled}
            />
            <i />Used
          </label>
        </div>
        <div className="col col-2">
          <label className="radio">
            <input
              type="radio"
              name="jewelryConditionGroup"
              value="handmade"
              checked={data.jewelryCondition === 'handmade'}
              onChange={onChangeFactory('jewelryCondition')}
              disabled={disabled}
            />
            <i />Handmade
          </label>
        </div>
      </div>
    </Field>
    <Field type="select" name="Type" error={error.jewelryType}>
      <select
        value={data.jewelryType}
        onChange={onChangeFactory('jewelryType')}
        disabled={disabled}
      >
        <option value="">Select type</option>
        <option value="-" disabled>
          -----
        </option>
        <option value="ring">Ring</option>
        <option value="mens-ring">Men's Ring</option>
        <option value="engagement-ring">Engagement Ring</option>
        <option value="wedding-band">Wedding Band</option>
        <option value="engagement-band-set">Engagement/Band Set</option>
        <option value="pendant">Pendant</option>
        <option value="bracelet">Bracelet</option>
        <option value="earrings">Earrings</option>
        <option value="stud-earrings">Stud Earrings</option>
        <option value="watch">Watch</option>
        <option value="wire-wrap">Wire Wrap</option>
        <option value="necklace">Necklace</option>
        <option value="broach">Broach</option>
        <option value="flexible-link-ring">Flexible Link Ring</option>
        <option value="coin">Coin</option>
        <option value="other">Other</option>
      </select>
      <i />
    </Field>
    <Field type="input" name="Brand" error={error.brand}>
      <input
        type="text"
        placeholder="Enter brand (i.e. Tacori)"
        value={data.brand}
        maxLength={15}
        onChange={onChangeFactory('brand')}
        disabled={disabled}
      />
      <div className="note">Maximum 15 characters, including spaces.</div>
    </Field>
    <Field type="input" name="Size" error={error.mountSize}>
      <input
        type="text"
        placeholder="Enter size (i.e. 3)"
        value={data.mountSize}
        onChange={onChangeFactory('mountSize')}
        disabled={disabled}
      />
    </Field>
    <Field type="select" name="Metal Type" error={error.metalType}>
      <select
        value={data.metalType}
        onChange={onChangeFactory('metalType')}
        disabled={disabled}
      >
        <option value="">Select metal type</option>
        <option value="-" disabled>
          -----
        </option>
        <option value="yellow-gold">Yellow Gold</option>
        <option value="white-gold">White Gold</option>
        <option value="rose-gold">Rose Gold</option>
        <option value="silver">Silver</option>
        <option value="platinum">Platinum</option>
        <option value="natural-wood">Natural Wood</option>
        <option value="other">Other</option>
      </select>
      <i />
    </Field>
    <Field type="select" name="Metal Purity" error={error.metalPurity}>
      <select
        value={data.metalPurity}
        onChange={onChangeFactory('metalPurity')}
        disabled={disabled}
      >
        <option value="">Select metal purity</option>
        <option value="-" disabled>
          -----
        </option>
        <option value="24k">24K</option>
        <option value="22k">22K</option>
        <option value="18k">18K</option>
        <option value="14k">14K</option>
        <option value="10k">10K</option>
        <option value="lessThan10k">Less than 10K</option>
        <option value="silver.992">Silver .992</option>
        <option value="silver.925">Silver .925</option>
        <option value="plated">Plated</option>
      </select>
      <i />
    </Field>
    <Field type="input" name="Metal Weight (g)" error={error.totalWeightGrams}>
      <input
        type="text"
        placeholder="Enter metal weight in grams"
        value={data.totalWeightGrams}
        onChange={onChangeFactory('totalWeightGrams')}
        disabled={disabled}
      />
    </Field>
  </fieldset>

export default JewelryInfo
